import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolbarType } from '../types';

// Ignored via go/ees005
// eslint-disable-next-line import/no-named-as-default
import ToolbarTextColor from './ToolbarTextColor';
var FloatingToolbarSettings = {
  disabled: false,
  isReducedSpacing: true
};
export function FloatingToolbarComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent;
  var _useSharedPluginState = useSharedPluginState(api, ['textColor']),
    textColorState = _useSharedPluginState.textColorState;
  return /*#__PURE__*/React.createElement(ToolbarTextColor
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  , {
    pluginState: textColorState,
    isReducedSpacing: FloatingToolbarSettings.isReducedSpacing,
    editorView: editorView,
    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
    disabled: FloatingToolbarSettings.disabled,
    pluginInjectionApi: api,
    toolbarType: ToolbarType.FLOATING
  });
}